import React from "react"
import Svg, { Ellipse, G, Path } from "react-native-svg"
import { View } from "react-native"

interface NewDealPointerProps {
  show: boolean
}

const NewDealPointer: React.FC<NewDealPointerProps> = ({ show }) => {
  if (!show) {
    return null
  }

  return (
    <View>
      <Svg height="42" width="152" viewBox="0 0 170 68">
        <G>
          <Ellipse
            cx="23.9"
            cy="24.5"
            rx="4.3"
            ry="2.3"
            transform="rotate(-84.079 23.9 24.5)"
            fill="#131F3A"
          />
          <Path d="M0,21.9l23.4-1.2L22.7,28L0,21.9z" fill="#131F3A" />
        </G>
      </Svg>
    </View>
  )
}

export default NewDealPointer
